import { Stack, Typography } from "@mui/material";
import { T } from "components/util/t";
import { forwardRef } from "react";

export const RankingsSummary = forwardRef(({ ranking, selectedSeries, selectedDivision }, ref) => (
    <Stack direction="row" flexWrap="wrap" ref={ref}>
        <Stack spacing={1} marginRight="auto" marginBottom={3}>
            <Typography color="textSecondary" variant="label2" textTransform="uppercase">{selectedSeries.name}</Typography>
            <Typography color="text.primary" variant="h7">{selectedDivision.name}</Typography>
        </Stack>
        <Stack direction="row" spacing={4} marginBottom={3}>
            <Stack spacing={1}>
                <Typography color="textSecondary" variant="label2" textTransform="uppercase"><T>Rank</T></Typography>
                <Typography color="text.primary" variant="h7"><T rank={ranking.place}>#rank</T></Typography>
            </Stack>
            <Stack spacing={1}>
                <Typography color="textSecondary" variant="label2" textTransform="uppercase"><T>Total points</T></Typography>
                <Typography color="text.primary" variant="h7">{ranking.points.toLocaleString()}</Typography>
            </Stack>
        </Stack>
    </Stack>
));
